<template>
	<h1>Modifier académie</h1>
	<form @submit.prevent="submit" class="form-container">
		<div class="input-container">
			<label for="Académie">Académie</label>
			<input
				type="text"
				class="form-control"
				v-model="form.name"
				id="Name"
				placeholder="Name"
			/>
		</div>
		<p v-if="status !== ''" class="status">{{ status }}</p>
		<p class="errors">{{ errors }}</p>
		<input class="submit dark" type="submit" value="Valider" />
	</form>
</template>

<script>
import { authenticatedApiFetch } from '../../utils/utils'

export default {
	data() {
		return {
			form: {
				academy: '',
			},
			errors: '',
		}
	},
	methods: {
		submit() {
			this.$store.dispatch('updateAcademy', this.form)
				.then(() => {
					this.$router.push({ name: 'SuperAdminAllAcademies' })
				})
				.catch((error) => {
					this.errors = error
				})
		},
		getAcademy() {
			authenticatedApiFetch(`/academies/${this.$route.params.id}/`, { method: 'GET' })
				.then(res => res.json())
				.then(res => {
					this.form = res
				})
		},
	},
	created() {
		this.getAcademy()
	},
}
</script>

<style>
</style>
